import { LOCAL_STORAGE_KEYS } from '../../constants/AppConstants';
import navigationVideosModel from '../../models/navigationVideosModel';
import { getLocale, PBStorage } from '../../services/storageService/GlobalData';

class NavigationVideosManager {
  async saveNavigationVideos(NavigationVideosToSave) {
    try {
      let videos = [];
      for (let i in NavigationVideosToSave) {
        videos.push(navigationVideosModel(NavigationVideosToSave[i]));
      }

      await PBStorage.set(LOCAL_STORAGE_KEYS.NAVIGATION_VIDEOS, videos);
      return true;
    } catch (e) {
      console.log('saveNavigationVideosfailed', e);
      return false;
    }
  }

  async getNavigationVideos(query = '') {
    let navigationVideos = await PBStorage.get(
      LOCAL_STORAGE_KEYS.NAVIGATION_VIDEOS,
    );

    // ensure videos exist in local storage
    if (navigationVideos !== null) {
      return navigationVideos.filter((q) =>
        q.locale[getLocale() === 'en' ? 0 : 1].title
          .toLowerCase()
          .includes(query.toLowerCase()),
      );
    } else return [];
  }
}

export default new NavigationVideosManager();
